export const MAX_PHOTOS = 100;
const MAX_FILE_BYTES = 20 * 1024 * 1024;
const MAX_ENCODED_BATCH = 5 * 1024 * 1024;

export async function preparePhoto(file) {
  if (!file.type.startsWith('image/') && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) throw new Error(`${file.name}: please choose a photo.`);
  if (file.size > MAX_FILE_BYTES) throw new Error(`${file.name}: choose a photo smaller than 20 MB.`);
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = () => reject(new Error(`${file.name}: this photo cannot be opened. Please save it as JPG or PNG and try again.`));
      img.src = url;
    });
    const scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Your browser cannot prepare photos. Please send them on WhatsApp instead.');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    let preview = canvas.toDataURL('image/jpeg', 0.82);
    if (preview.length > 512 * 1024) preview = canvas.toDataURL('image/jpeg', 0.65);
    if (preview.length > 512 * 1024) {
      canvas.width = Math.max(1, Math.round(canvas.width * 0.65));
      canvas.height = Math.max(1, Math.round(canvas.height * 0.65));
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, 0, 0, canvas.width, canvas.height);
      preview = canvas.toDataURL('image/jpeg', 0.65);
    }
    const contentInBase64 = preview.split(',')[1];
    if (contentInBase64.length > 512 * 1024) throw new Error(`${file.name}: this photo is too large. Please choose a smaller copy.`);
    return { id: `${file.name}:${file.size}:${file.lastModified}`, name: file.name.replace(/\.[^.]+$/, '') + '.jpg', contentType: 'image/jpeg', contentInBase64, preview };
  } finally {
    URL.revokeObjectURL(url);
  }
}

export function photoBatches(photos) {
  const batches = [];
  let current = [];
  let bytes = 0;
  for (const photo of photos) {
    if (current.length && (bytes + photo.contentInBase64.length > MAX_ENCODED_BATCH || current.length >= 25)) {
      batches.push(current);
      current = [];
      bytes = 0;
    }
    current.push({ name: photo.name, contentType: photo.contentType, contentInBase64: photo.contentInBase64 });
    bytes += photo.contentInBase64.length;
  }
  if (current.length || !batches.length) batches.push(current);
  return batches;
}

